import {AuthService} from './Service';
import {useState} from 'react';
import store from '../../core/store';
import {loginSuccess} from '../../core/store/auth/reducers';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-hot-toast';
import {loadModules} from "../../core/store/company/reducers";

const Login = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [service] = useState(new AuthService());

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        const res = await service.login(username, password);
        if (res != null) {
            toast.success('Login success');
            store.dispatch({
                type: loginSuccess,
                payload: res
            });
            store.dispatch({
                type: loadModules,
                payload: res
            });
            navigate('/', {replace: true});
        }
    };

    return (
        <>
            <div className="main-wrapper login-body">
                <div className="login-wrapper">
                    <div className="container">
                        <img
                            className="img-fluid logo-dark mb-2 logo-color"
                            src="/assets/img/softcom-black.png"
                            alt="Logo"
                        />
                        <img
                            className="img-fluid logo-light mb-2"
                            src="/assets/img/logo2-white.png"
                            alt="Logo"
                        />
                        <div className="loginbox">
                            <div className="login-right">
                                <div className="login-right-wrap">
                                    <h1>Login</h1>
                                    <p className="account-subtitle">Access to our dashboard</p>
                                    <form onSubmit={handleSubmit}>
                                        <div className="input-block mb-3">
                                            <label className="form-control-label">Email</label>
                                            <input type="username" className="form-control" value={username}
                                                   onChange={(e) => setUsername(e.target.value)} required={true}/>
                                        </div>
                                        <div className="input-block mb-3">
                                            <label className="form-control-label">Password</label>
                                            <div className="pass-group">
                                                <input type="password" className="form-control pass-input"
                                                       name="password" value={password}
                                                       onChange={(e) => setPassword(e.target.value)} required={true}/>
                                                <span className="fas fa-eye toggle-password"/>
                                            </div>
                                        </div>
                                        <button className="btn btn-lg  btn-primary w-100" type="submit">
                                            Login
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Login;
